import React from "react";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import "./OurFoundersWidget.css";

import FounderSN from "../../../images/founder-sn.png";
import FounderRC from "../../../images/founder-rc.png";
import FounderBE from "../../../images/founder-be.png";

const OurFoundersWidget = () => {
    const handleShowMoreText = event => {
        let showMoreLessTextNode = event.target;
        let contentNode = event.target.previousSibling;
        if (
            contentNode.classList.contains(
                "our-founders-container__item__full-description"
            )
        ) {
            showMoreLessTextNode.textContent = "More";
        } else {
            showMoreLessTextNode.textContent = "See Less";
        }

        contentNode.classList.toggle(
            "our-founders-container__item__full-description"
        );
    };
    return (
        <WidgetContainer>
            <h2 className="our-founders-heading">Our Founders</h2>
            <div className="our-founders-container">
                <div className="our-founders-container__item" id="ceo">
                    <div className="our-founders-container__item__img">
                        <img
                            src={FounderSN}
                            alt="Sameer Nigam, Co-founder & CEO"
                        />
                    </div>
                    <h3 className="our-founders-container__item__name">
                        Sameer Nigam
                    </h3>
                    <div className="our-founders-container__item__description">
                        Sameer Nigam founded PhonePe in 2015 and serves as its
                        Chief Executive Officer. Before PhonePe, he served as
                        the SVP Engineering and VP Marketing at Flipkart. His
                        Flipkart journey started in 2011 when the company
                        acquired his earlier startup - Mime360, a digital media
                        distribution platform. Sameer has also served as the
                        Director of Product Management at Shopzilla Inc, where
                        he built the company's proprietary shopping search
                        engine. In 2009, he won the coveted Wharton Venture
                        Award, bestowed by the prestigious Wharton Business
                        School. He holds an MBA from the Wharton Business School
                        (University of Pennsylvania), USA, and a Master’s degree
                        in Computer Science from the University of Arizona,
                        Tucson-USA.
                    </div>
                    <p
                        className="our-founders-container__item__more"
                        onClick={handleShowMoreText}
                    >
                        More
                    </p>
                </div>
                <div className="our-founders-container__item" id="cto">
                    <div className="our-founders-container__item__img">
                        <img
                            src={FounderRC}
                            alt="Rahul Chari, Co-founder & CTO"
                        />
                    </div>
                    <h3 className="our-founders-container__item__name">
                        Rahul Chari
                    </h3>
                    <div className="our-founders-container__item__description">
                        Rahul Chari is the Chief Technology officer at PhonePe.
                        He comes with two decades of experience spanning
                        embedded systems, enterprise software development,
                        e-commerce platforms and apps. Prior to PhonePe he was
                        working as the VP Engineering at Flipkart and was
                        responsible for building the best-in-class supply chain
                        system for e-commerce. He joined Flipkart in 2011
                        through the acquisition of Mallers Inc where he served
                        as the Chief Technology Officer and built Mime360, their
                        flagship product. Prior to Mallers, Rahul was with the
                        Data Center Business Unit at Cisco Systems where he was
                        part of the team that developed the market changing MDS
                        9000 family of SAN switches. He is named on multiple
                        storage virtualization related patents. Rahul holds a
                        Masters degree in Computer Science from Purdue
                        University, USA and a Bachelor's degree in Computer
                        Engineering from Bombay (Mumbai) University, India (Gold
                        Medalist).
                    </div>
                    <p
                        className="our-founders-container__item__more"
                        onClick={handleShowMoreText}
                    >
                        More
                    </p>
                </div>
                <div className="our-founders-container__item" id="cro">
                    <div className="our-founders-container__item__img">
                        <img
                            src={FounderBE}
                            alt="Burzin Engineer, Chief Reliability Officer"
                        />
                    </div>
                    <h3 className="our-founders-container__item__name">
                        Burzin Engineer
                    </h3>
                    <div className="our-founders-container__item__description">
                        Burzin is the Chief Reliability Officer at PhonePe. He
                        has more than 25 years of experience in the dot-com
                        space. During his stint at PhonePe, he has built web
                        scale infrastructure and led multiple engineering
                        projects including running and building PhonePe's web
                        serving layer, cloud systems, network, storage and CDN.
                        He’s passionate about building software at scale.
                        Previously, he helped build Mime360, the flagship
                        product at Mallers Inc. He set up their web services,
                        Internal-IT, Application Engineering, Storage Networks
                        and Configuration Services. While at Mallers Inc, he
                        helped redesign the company’s infrastructure for
                        unprecedented growth (100% year over). He holds a Master
                        of Science in Computer Science from the University of
                        Southern California.
                    </div>
                    <p
                        className="our-founders-container__item__more"
                        onClick={handleShowMoreText}
                    >
                        More
                    </p>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default OurFoundersWidget;
